import { IAddress } from "../models";

export default (address: IAddress | undefined): string | undefined => {
  if (!address) {
    return undefined;
  }

  return [
    address.address,
    address.address2,
    address.city,
    address.state,
    address.zip,
    address.country,
  ]
    .filter(Boolean)
    .join(', ');
};
